import React from 'react';
import { isEmpty } from 'lodash';
import { Link } from 'react-router-dom';

import ListItem from '@material-ui/core/ListItem';
import Tooltip from '@material-ui/core/Tooltip';

import ACButton from '../../atoms/ACButton';
import { getInternalBaseUrl } from '../../common/global.js';
import { getChallengeTypes } from '../../common/challenges.js';

import styles from './Stop.module.scss';

export default class Stop extends React.Component {
  onClickStop = () => {
    const { stop = {}, onClickStopFunc } = this.props;
    onClickStopFunc(stop);
  };

  onDragStopStart = (e) => {
    const { stop = {} } = this.props;
    const { index = -1 } = stop;
    e.dataTransfer.setData('text/plain', index);

    e.stopPropagation();
  };

  onDragStopOver = (e) => {
    const { stop = {}, highlightDestinationFunc } = this.props;
    const { index = -1 } = stop;
    e.preventDefault();
    e.stopPropagation(); // Don't send it further
    highlightDestinationFunc(index);
  };

  // TODO: Test drag\drop as it has a slight change.
  onDropStop = (e) => {
    const { stop = {}, onSwapFunc } = this.props;
    const { index = -1 } = stop;
    const from = e.dataTransfer.getData('text');
    const to = index;
    onSwapFunc(from, to);

    e.stopPropagation();
  };

  renderSparkPart() {
    const { stop = {} } = this.props;
    const { spark = {}, challenge = {}, note = {}, index = -1 } = stop;
    if (isEmpty(spark)) return null;

    let sparkURL = getInternalBaseUrl().sparks + '?id=' + spark.id || '';
    const challenegeTypes = getChallengeTypes();
    const cType =
      challenegeTypes.find((cType) => {
        return cType.value === challenge.type || '';
      }) || {};
    const cTypeName = cType.name || '';

    return (
      <Link
        to={sparkURL}
        style={{ textDecoration: 'none', color: 'inherit' }}
        onClick={(e) => {
          // This has been done to stop default onClick behaviour of the Link.
          e.preventDefault();
        }}
      >
        <ListItem className={styles.sparkRoot} onClick={this.onClickStop}>
          <div className={styles.clue}>
            <div className={styles.mediumColumn}>{index + 1}</div>
            <div className={styles.clueDetails}>
              <span className={styles.boldFont}>{spark.name || ''}</span>
            </div>
            <div className={styles.largeColumn}>
              <span
                style={{
                  fontSize: '12px',
                }}
              >
                {note.private || ''}
              </span>
            </div>
            {!isEmpty(cTypeName) ? (
              <Tooltip title={cTypeName}>
                <div className={styles.mediumColumn}>
                  <ACButton
                    text={cTypeName}
                    backgroundColor={'#616161'}
                    spanMargin="0 0"
                    color={'white'}
                  />
                </div>
              </Tooltip>
            ) : null}
          </div>
        </ListItem>
      </Link>
    );
  }

  renderChallengePart() {
    const { stop = {} } = this.props;
    const { challenge = {} } = stop;
    if (isEmpty(challenge)) return <div />;
    return (
      <ListItem className={styles.challengeRoot} onClick={this.onClickStop}>
        <div className={styles.largeColumn}>{challenge.name || ''}</div>
      </ListItem>
    );
  }

  render() {
    const { highlight, stop = {} } = this.props;

    let borderColor = '#52A8EF';
    let borderStyle = 'none';
    let padding = '0px';

    if (highlight === stop.index) {
      borderColor = '#52A8EF';
      borderStyle = 'dashed';
      padding = '5px';
    }
    return (
      <div
        className={styles.root}
        draggable
        onDragStart={this.onDragStopStart}
        onDragOver={this.onDragStopOver}
        onDrop={this.onDropStop}
      >
        <div
          className={styles.list}
          style={{
            borderColor: borderColor,
            borderStyle: borderStyle,
            padding: padding,
          }}
        >
          {this.renderSparkPart()}
          {this.renderChallengePart()}
        </div>
      </div>
    );
  }
}
